/**
 * Created by jv on 23/01/2017.
 */
const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/languagemanager");
const ElementCreator = require("Sources/components/element-creator");
const TableCreator = require("Sources/components/table-creator");
const Dialog = require("Sources/utils/modal");
const Collapse = require("Sources/components/collapse");
const Tooltip = require("Sources/components/tooltip");
const activationsTableHeader = require("Data/table-headers/activations-header");
const TokenTableRowTemplate = require("Sources/templates/token-table-row.template");

// Styles
require("Styles/components/tokens.scss");

module.exports = class TokenTemplate
{
  constructor(options)
  {
    /*
     * options.appendTo
     * options.token
     * options.type (installations | users)
     * options.collapsible
     * options.lazyload (only when collapsible is true and getActivations is a function)
     *
     * options.getActivations
     * options.increaseMax
     * options.deactivateActivation
     * options.activationsCounter
     */

    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    this.appendTo = $(options.appendTo);
    this.collapsible = utils.isBoolean(options.collapsible) ? options.collapsible : true;
    this.lazyload = utils.isBoolean(options.lazyload) ? (options.lazyload && this.collapsible) : true;

    this.showOnlyActivationTable = utils.isBoolean(options.showOnlyActivationTable) ? options.showOnlyActivationTable : false;

    this.token = options.token;
    this.type = this.token.activationType;

    this.getActivations = options.getActivations;
    this.increaseMax = options.increaseMax;
    this.deactivateActivation = options.deactivateActivation;

    this.tokenWrapperEl = null;
    this.collapseContentEl = null;
    this.activationsTableWrapper = null;

    this.activationsLoaded = !this.lazyload;

    this.activationsCounter = options.activationsCounter;

    this.create();
  }

  create()
  {
    if(this._initialized !== true)
    {
      var that = this;


      // %NOTE: this is a quick shortcut - maybe better to create a different template for the new v3.0 token?
      if(this.showOnlyActivationTable)
      {
        this.activationsTableWrapper = this.appendTo;

        this.activationsLoaded = true;
        this.getActivations(that.token.key, function()
        {
          that.renderActivationsTable();
        });
      }
      else
      {

        this.tokenWrapperEl =$("<div class='token-wrapper'></div>");
        this.appendTo.append(this.tokenWrapperEl);
        this.renderToken();

        if(this.collapsible)
        {
          var collapseOptions = {
            selector: this.tokenWrapperEl
          };

          if(this.lazyload && utils.isFunction(this.getActivations))
          {
            collapseOptions.onExpand = function(thisEl, e)
            {
              that.loadActivations(thisEl, e);
            };
          }

          Collapse.makeCollapsible(collapseOptions);
        }
      }


      this._initialized = true;
    }
  }

  loadActivations(thisEl, e)
  {
    if(!this.activationsLoaded)
    {
      var that = this;

      that.activationsLoaded = true;

      that.getActivations(that.token.key, function()
      {
        that.renderCollapseContent();
      });
    }
  }

  reload(token)
  {
    this.token = token;
    this.renderCollapseContent();
  }

  rerender()
  {
    if(this.showOnlyActivationTable)
    {
      this.activationsTableWrapper.empty();
      this.renderActivationsTable();
    }
    else
    {
      this.renderCollapseContent();
    }
  }

  renderToken()
  {
    this.renderTokenTitle();
    this.renderCollapseWrapper();
  }

  renderTokenTitle()
  {
    var tmpTokenTitle = this.tokenWrapperEl.find(".token-title");

    if(tmpTokenTitle.length)
    {
      tmpTokenTitle.remove();
    }

    var platformElements = ElementCreator.createStringElement({
      classNames: [ "platforms" ],
      innerHTML: this.token.getHTMLIconsFormPlatforms()
    });

    this.tokenWrapperEl.append(ElementCreator.createStringElement({
      classNames: [ "token-title" ],
      attributes: [
        { name: "data-trigger" }
      ],
      innerHTML: this.token.code + platformElements
    }));

    this.tokenWrapperEl.find(".token-title .platforms i.icon").each(function()
    {
      var $this = $(this);
      var dataType = $this.attr("data-type");

      switch(dataType)
      {
        case "picture_ios":
        case "avi_ios":
          Tooltip.create({
            selector: $this,
            content: LanguageManager.getValueForKey("subscription_details.tokens.activations.platforms.ios.tooltip.text")
          });
          break;
        case "picture_android":
          Tooltip.create({
            selector: $this,
            content: LanguageManager.getValueForKey("subscription_details.tokens.activations.platforms.android.tooltip.text")
          });
          break;
        case "picture_pc":
          Tooltip.create({
            selector: $this,
            content: LanguageManager.getValueForKey("subscription_details.tokens.activations.platforms.windows.tooltip.text")
          });
          break;
        case "avi_web":
          Tooltip.create({
            selector: $this,
            content: LanguageManager.getValueForKey("subscription_details.tokens.activations.platforms.web.tooltip.text")
          });
          break;
        default:
          break;
      }
    });
  }

  renderCollapseWrapper()
  {
    if(utils.isNotNull(this.collapseWrapperEl) && this.collapseWrapperEl.length)
    {
      this.collapseWrapperEl.remove();
    }

    this.collapseWrapperEl = $("<div data-target></div>");

    if(!this.lazyload)
    {
      this.renderCollapseContent();
    }

    this.tokenWrapperEl.append(this.collapseWrapperEl);
  }

  renderCollapseContent()
  {
    if(utils.isNull(this.collapseWrapperEl) || !this.collapseWrapperEl.length)
    {
      return;
    }

    if(utils.isNotNull(this.collapseContentEl) && this.collapseContentEl.length)
    {
      this.collapseContentEl.remove();
    }

    this.collapseContentEl = $("<div class='token-data'></div>");

    this.renderTokenInfo();
    this.renderActivationsTableWrapper();

    this.collapseWrapperEl.append(this.collapseContentEl);
  }

  renderTokenInfo()
  {
    var that = this;
    var tmpTokenDataEl = this.tokenWrapperEl.find(".token-data");

    if(tmpTokenDataEl.length)
    {
      tmpTokenDataEl.remove();
    }

    var installationsLabelLocaleKey = "subscription_details.tokens.activations.installations_used";
    var currentCount = this.token.currentActivationsCount;
    var maxCount = this.token.maxInstallations;

    if(this.type === "users")
    {
      installationsLabelLocaleKey = "subscription_details.tokens.activations.users_active";
      maxCount = this.token.maxUsers;
    }

    var infoLabel = ElementCreator.createStringElement({
      classNames: [ "info-label" ],
      innerHTML: LanguageManager.getValueForKey(installationsLabelLocaleKey)
    });

    var infoValue = ElementCreator.createStringElement({
      classNames: [ "info-value" ],
      innerHTML: currentCount + "/" + maxCount
    });

    var action = $("<button class='btn btn-icon frameless add-circle dark-grey max-install-btn'></button>").on("click", function(e)
    {
      if(utils.isFunction(that.increaseMax))
      {
        that.increaseMax(that);
      }
    });

    var infoRow = $(ElementCreator.createStringElement({
      classNames: [ "info-row" ],
      innerHTML: infoLabel + infoValue
    })).append(action);

    this.collapseContentEl.append(infoRow);
  }

  renderActivationsTableWrapper()
  {
    if(utils.isNotNull(this.activationsTableWrapper))
    {
      this.activationsTableWrapper.remove();
    }

    var titleEl = ElementCreator.createStringElement({
      tagName: "h6",
      classNames: [ "activation-table-label" ],
      innerHTML: LanguageManager.getValueForKey("subscription_details.tokens.activations.title")
    });

    var tooltipEl = $("<button type='button' class='btn btn-icon question-circle frameless'></button>");
    Tooltip.create({
      selector: tooltipEl,
      trigger: "hover",
      title: LanguageManager.getValueForKey("subscription_details.tokens.activations.tooltip.title"),
      content: LanguageManager.getValueForKey("subscription_details.tokens.activations.tooltip.text"),
      placement: "right"
    });

    var titleWrapper = $("<div></div>").append(titleEl).append(tooltipEl);

    this.activationsTableWrapper = $("<div class='activations-table-wrapper'></div>").append(titleWrapper);

    this.collapseContentEl.append(this.activationsTableWrapper);

    this.renderActivationsTable();
  }

  renderActivationsTable()
  {
    var that = this;

    if(this.token.currentActivations !== null && this.token.currentActivations.length > 0)
    {
      if (this.activationsCounter)
        this.activationsCounter.get(0).innerHTML = "" + this.token.currentActivations.length + "/" + this.token.maxInstallations;

      var tcActivations = new TableCreator({
        headers: activationsTableHeader,
        data: this.token.currentActivations,
        appendTo: this.activationsTableWrapper,
        headerTemplate: TokenTableRowTemplate.createTableHeader,
        bodyTemplate: TokenTableRowTemplate.createTokenRow,
        rowIdProperty: "fakeKey",
        sortable: true,
        afterRender: function(element)
        {
          var $el = $(element);

          Tooltip.create({
            selector: $el.find(".activation-installation-tooltip"),
            content: LanguageManager.getValueForKey("subscription_details.tokens.activations.installation.tooltip.text")
          });

          $el.find(".deactivate-token-btn").off("click").on("click", function(e)
          {
            var fakeActivationKey = $(this).closest(".fo-row").attr("data-row-fakekey");

            var activation = that.token.getActivationForFakeKey(fakeActivationKey);

            if(utils.isFunction(that.deactivateActivation))
            {
              Dialog.showYesNoDialog("subscription_details.tokens.activations.deactivate.dialog.title", "subscription_details.tokens.activations.deactivate.dialog.text", function()
              {
                that.deactivateActivation(activation, that);
              });
            }
          });
        }
      });

      tcActivations.create();
    }
    else
    {
      this.activationsTableWrapper.append("<p class='activation-table-none'>" + LanguageManager.getValueForKey("subscription_details.tokens.activations.empty") + "</p>");
    }

  }
};



// WEBPACK FOOTER //
// ./app/js/templates/token.template.js